export default __webpack_public_path__ + "static/media/info.7bd49db8.svg";